import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from '../root-route'
import { AppShell } from '@/app/layouts/AppShell'
import { sessionQuery } from '@/entities/session'
import { isProblem } from '@/shared/api'

/**
 * Всё, что под шапкой. Шапку рисует `AppShell`.
 *
 * Здесь же — единственный охранник компании. Под этим роутом нет ни одного экрана, который
 * имел бы смысл без неё: ни броней, ни шахматки, ни задач. Пользователь без компаний должен
 * попасть на `/no-companies`, а не смотреть на пустую оболочку.
 *
 * Проверка стоит в `beforeLoad` родителя, а не внутри `AppShell`, по одной причине: `beforeLoad`
 * отрабатывает ДО загрузчиков дочерних роутов. Иначе (в фазе 2, когда у экранов появятся
 * loader'ы) пользователь без компании успел бы выстрелить заведомо обречённым запросом — сервер
 * всё равно не знает, какую компанию ему показывать.
 */
export const shellRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'shell',
  beforeLoad: async ({ context, location }) => {
    let session

    try {
      session = await context.queryClient.ensureQueryData(sessionQuery())
    } catch (error) {
      // 401 здесь — не сбой, а «сессия кончилась»: уводим на вход, запомнив, куда шли.
      //
      // Глобальный перехватчик (`App.tsx`, `setupHttp`) на 401 делает то же самое, так что этот
      // редирект с ним дублируется. Дублируется НАМЕРЕННО: без него ошибка полетела бы дальше
      // из `beforeLoad`, роутер показал бы экран смерти — и человек увидел бы его вспышку поверх
      // уже начавшейся навигации на вход.
      if (isProblem(error) && error.status === 401) {
        throw redirect({ to: '/login', search: { redirect: location.href } })
      }
      throw error
    }

    if (!session.company) throw redirect({ to: '/no-companies' })
  },
  component: AppShell,
})

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
